import { Component } from '@angular/core';
import { NgxSpinnerService } from 'ngx-spinner';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';
import Swal from 'sweetalert2';
import { PagehelpmodalService } from './pagehelpmodal.service';

@Component({
  selector: 'app-pagehelpmodal',
  templateUrl: './pagehelpmodal.component.html',
  styleUrls: ['./pagehelpmodal.component.css']
})
export class PagehelpmodalComponent {
  apiurl = '';
  componentid = 0;
  productid = 22
  text = ""
  constructor(public config: DynamicDialogConfig, public ref: DynamicDialogRef, private helpservice: PagehelpmodalService, private spinner: NgxSpinnerService) {
    const dataFromParent = this.config.data;
    this.apiurl = dataFromParent.api;
    this.componentid = dataFromParent.componentid;
  //   if(dataFromParent.productid!==null || dataFromParent.productid!==undefined)
  //  { this.productid=dataFromParent.productid}else{
  //   this.productid=0
  //  }
    if (this.componentid !== 0) { this.getdata() }

  }
  closemodal() {
    this.ref.close()
  }
  getdata() {
    this.spinner.show();
    this.helpservice.gethelpdata(this.componentid, this.productid).subscribe(res => {
      this.spinner.hide()
      this.text = res[0].response
    }, error => {
      this.spinner.hide();
      const timestamp = new Date().toLocaleString();
      Swal.fire({
        title: error.error.response,
        text: `This event occurred at: ${timestamp}`,
        icon: 'error'
      })
      this.ref.close()
    })
  }
}
